
<!--Reports Dashboard start-->
<div class="row" style="margin-bottom: 20px;">
  <div class="col-md-2" style="margin-left: 40px; margin-top:1rem">
  <label style="margin-left: 3rem; font-weight: bold; font-size: 15px;">Show Reports From:</label>
  </div>

  
  <div class="col-md-4" style="padding-left: 1px; margin-top:1rem" >
    <select class="form-control" [(ngModel)]="period" style="padding: 1px 5px; width: 70%;"  (change)="onChange()"> 
      <option *ngFor="let c of periodIntervals" [ngValue]="c">{{c}}</option>
    </select>
  </div>
  
</div>
<div class="row" *ngIf="period == 'DateRange'">
  <div class="col-md-2" style="margin-left: 40px;">
    <label  style="margin-left: 3rem;">From Date:</label>
  </div>
  <div class="col-md-3" style="padding-left: 1px;">
    <div class="row">
  <input type="date" class="form-control" style="padding: 1px 5px; width: 45%;" [(ngModel)]="FromDate" (change)="changeFromDate($event.target.value,'AD')">
  <input type="text" class="form-control" style="padding: 1px 5px; width: 45%; margin-left: 0.5rem;" [(ngModel)]="FromDateBS" (change)="changeFromDate($event.target.value,'BS')">
  </div>
  </div>
  <div class="col-md-1">
    <label >To Date:</label>
  </div>
  <div class="col-md-3" style="padding-left: 1px;">
    <div class="row">
    <input type="date" class="form-control" style="padding: 1px 5px; width: 45%;" [(ngModel)]="ToDate" (change)="changeToDate($event.target.value,'AD')">
    <input type="text" class="form-control" style="padding: 1px 5px; width: 45%; margin-left: 0.5rem;" [(ngModel)]="ToDateBS" (change)="changeToDate($event.target.value,'BS')" >
    </div>
  </div>
  <div class="col-md-1" style="margin-left: 2rem;">
  <button type="button" (click)="run()" class="btn btn-primary btn-sm">RUN</button>
    </div>
</div>





<div class="container" style="margin-left: 10rem;" *ngIf="finalresult">
  
  <div class="row" style="margin-top: 30px;">

    <div class="col-md-2 tile blue">
      <div class="row">
        <h6>Total Sales</h6>
      </div>
      <div class="row">
        <p>{{totalsales | number:'1.0-2'}}</p>
      </div>
    </div>
    
    <div class="col-md-2 tile blue">
      <div class="row">
        <h6>Total Bill</h6>
      </div>
      <div class="row">
        <p>{{totalbill | number:'1.0-2'}}</p>
      </div>
    </div>

    <div class="col-md-2 tile blue">
      <div class="row">
        <h6>Unit Sold</h6>
      </div>
      <div class="row">
        <p>{{unitsold | number:'1.0-2'}}</p>
      </div>
    </div>

    <div class="col-md-2 tile blue">
      <div class="row">
        <h6>Average Basket Value</h6>
      </div>
      <div class="row">
        <p>{{avgBasketVal | number:'1.0-2'}}</p>
      </div>
    </div>

    <div class="col-md-2 tile blue" >
      <div class="row">
        <h6>Average Sku Value</h6>
      </div>
      <div class="row">
        <p>{{avgSkuVal | number:'1.0-2'}}</p>
      </div>
    </div>

  </div>

  <div class="row" style="margin-top: 30px;">
    <div class="col-md-10" >
      <h6>Total Sales Owner vs Franchise</h6>
      <div class="chart-wrapper">
        <canvas baseChart #ownerFranchise="base-chart"
        [data]="ownerFranchiseData" 
        [labels]="ownerFranchiseLabels" 
        [chartType]="ownerFranchiseType"
        [legend]="ownerFranchiseLegend"
        [options]="ownerFranchiseOptions"
        [plugins]="ownerFranchisePlugins">
        
      </canvas>
    </div>
    </div>

  </div>

  <div class="row" style="margin-top: 30px;">
    <div class="col-md-10">
      <h6>State wise Sales</h6>
      <div class="chart-wrapper">
        <canvas baseChart #stateWiseSales="base-chart"
        [data]="StateWiseData"
        [labels]="StateWiseLabels"
        [colors]="StateWiseColor"
        [chartType]="StateWiseType"
        [legend]="StateWiseLegend"
        [options]="StateWiseOptions">
      </canvas>
      </div>
    </div>
  </div>

  <div class="row" style="margin-top: 30px;">
    <div class="col-md-10">
      <h6>Store wise Sales</h6>
       <div class="chart-wrapper">
        <canvas baseChart  #storeWiseSales="base-chart" width="950" height="510"
        [data]="StoreWiseData"
        [labels]="StoreWiseLabels"
        [chartType]="StoreWiseType"
        [colors]="StoreWiseColor"
        [legend]="StoreWiseLegend"
        [options]="StoreWiseOptions">
      </canvas>
      </div>
    </div>
  </div>

  <div class="row" style="margin-top: 30px;">
    <table class="table table-striped" style="width: 60rem;">
      <thead>
        <tr style="position: sticky; top:0;line-height: 1.5rem;">
          <th scope="col" style="width:3%">S.N</th>
          <th scope="col" style="width:18%">Store Name</th>
          <th scope="col" style="width:10%;">Total Sales</th>
      </tr>
      </thead>
      <tbody>
        <tr *ngFor="let store of storeWiseSalesList; let i=index">
          <td style="width: 3%;">{{i+1}}</td>
          <td style="width: 18%;">{{store.StoreName}}</td>
          <td style="width: 10%;">{{store.TotalSales | number:'1.0-2'}}</td>

        </tr>

      </tbody>

    </table>
  </div>
    


   

  <div class="row" style="margin-top: 30px;" *ngIf="this.finalresult.result.categoryWiseTopSales.length !== 0">
    <div class="col-md-10">
      <h6>Category Wise Top Sales</h6>
      <div class="chart-wrapper">
        <canvas baseChart #categoryTop="base-chart"
        [data]="topsalesCategoryData" 
        [labels]="topsalesCategoryLabels" 
        [chartType]="topsalesCategoryType"
        [legend]="topsalesCategoryLegend"
        [options]="topsalesCategoryOptions"
        [plugins]="topsalesCategoryPlugins">
      </canvas>
    </div>
    </div>
  </div>


<div class="row" style="margin-top: 30px;" *ngIf="this.finalresult.result.categoryWiseWorstSales.length !== 0">
    <div class="col-md-10">
      <h6>Category Wise Worst Sales</h6>
      <div class="chart-wrapper">
        <canvas baseChart #categoryWorst="base-chart"
        [data]="worsesalesCategoryData" 
        [labels]="worsesalesCategoryLabels" 
        [chartType]="worsesalesCategoryType"
        [legend]="worsesalesCategoryLegend"
        [options]="worsesalesCategoryOptions"
        [plugins]="worsesalesCategoryPlugins">
      </canvas>
    </div>
    </div>

  </div>

  <div class="row" style="margin-top: 30px;" *ngIf="this.finalresult.result.itemWiseTopSales.length !== 0">
    <div class="col-md-10">
      <h6>Item Wise Top Sales</h6>
      <div class="chart-wrapper">
        <canvas baseChart #itemWiseTop="base-chart"
        [data]="topSalesItemData" 
        [labels]="topSalesItemLabels" 
        [chartType]="topSalesItemType"
        [legend]="topSalesItemLegend"
        [options]="topSalesItemOptions"
        [plugins]="topSalesItemPlugins">
      </canvas>
    </div>
    </div>
  </div>

  <div class="row" style="margin-top: 30px;" *ngIf="this.finalresult.result.itemWiseWorstSales.length !== 0">
    <div class="col-md-10">
      <h6>Item Wise Worst Sales</h6>
      <div class="chart-wrapper">
        <canvas baseChart #itemWiseWorst="base-chart"
        [data]="worseSalesItemData" 
        [labels]="worseSalesItemLabels" 
        [chartType]="worseSalesItemType"
        [legend]="worseSalesItemLegend"
        [options]="worseSalesItemOptions"
        [plugins]="worseSalesItemPlugins">
      </canvas>
    </div>
    </div>

  </div>

</div>

<!--Reports Dashboard end-->

<!-- <div class="row" style="height: 90vh;" class="loginImage">

</div> -->

<style>
  .loginImage{
    background-image: url('assets/clipart1427049.png');
    background-size: 32vw,0vw ;
  }
</style>
